import styled from 'styled-components';

import { responsive } from '@/utils';

export const SiteCardsGrid = styled.div`
  display: grid;
  /* 100% lets a column shrink on a narrow screen; a fixed 13.75rem minimum gets clipped. */
  grid-template-columns: repeat(auto-fill, minmax(min(100%, 13.75rem), 1fr));
  gap: ${responsive.spacing.large};
  width: 100%;
  align-content: start;
`;
